import React from 'react';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import styles from './GalleryItem.module.scss';
type IGalleryItem = {
  item: any;
  onClick: () => void;
};
const defaultPlaceholder = 'https://api.shab.ir/img/cities/426.png'; // TODO: change it later

const GalleryItem = ({
  item,
  onClick
}: IGalleryItem) => {
  return <Box component={'figure'} className={styles['gallery-item']} data-sentry-element="Box" data-sentry-component="GalleryItem" data-sentry-source-file="GalleryItem.tsx">
      <Image layout="fill" objectFit="cover" src={item?.path || item?.hq_thumbnail_path || item?.thumbnail_path || defaultPlaceholder} alt={item?.caption || item?.title} title={item?.title} onClick={onClick} data-sentry-element="Image" data-sentry-source-file="GalleryItem.tsx" />
    </Box>;
};
export default GalleryItem;